<script lang="ts">
	import { formatFulfilmentDates } from '$utils/common';
	import type { PageData } from '../../$types';
	import { type productType, type productCartType } from '../../../ambient.d';
	import { cart } from '../../../stores/cart';
	import { productExtras } from '$utils/productExtras';
	import { flavours } from '$utils/Flavours';
	import { toasts } from '$stores/toasts';
	import { goto } from '$app/navigation';

	interface PageData {
		status: number;
		product: productType;
		relatedProducts: Array<
			| {
					id: string;
					name: string;
					description: string;
					price: number;
					thumbnail: { src: string; alt: string };
			  }
			| undefined
		>;
	}
	export let data: PageData;
	let sizeChoice: number = 0;
	let sizePrice = 0;
	let quantityChoice: number = 0;
	let QuantityPrice = 0;
	let flavourPrice = 0;
	let extrasChoice: {
		[key: string]: { type: string; value: string | undefined; price: number };
	} = getInitialExtras();
	let extrasPrice: number = 0;
	let totalPrice: number;
	let productQuantity: number = 1;
	let product: productCartType = {
		_id: data.product._id,
		name: data.product.name,
		category: data.product.category,
		thumbnail: data.product.thumbnail,
		fulfilmentDates: data.product.fulfilmentDates,
		price: 0,
		size: undefined,
		quantity: undefined,
		shape: undefined,
		flavour: undefined,
		topFlavour: undefined,
		bottomFlavour: undefined,
		packOneFlavour: undefined,
		packTwoFlavour: undefined,
		packThreeFlavour: undefined,
		packFourFlavour: undefined,
		extras: undefined,
		instructions: undefined
	};
	let productNotesList: string[] = generateNotesList();
	let productAllergensList: string[] = generateAllergensList();
	let selects: { [key: string]: HTMLSelectElement } = {};
	let minPrice: number = getMinPrice();
	let maxPrice = getMaxPrice();
	let additionalImages: string[] = data.product.images.map((image) => {
		return `https://takethecake.gumlet.io/${data.product._id}/${image.src.replace(
			' ',
			'%20'
		)}`;
	});

	function getInitialExtras() {
		let initialExtras: {
			[key: string]: { type: string; value: string | undefined; price: number };
		} = {};
		if (data.product.extras) {
			data.product.extras.forEach((extra) => {
				if (productExtras[extra].default) {
					initialExtras[extra] = {
						type: productExtras[extra].type,
						value: productExtras[extra].default.toString(),
						price: productExtras[extra].price
					};
				}
			});
		}
		return initialExtras;
	}

	function getMinPrice(): number {
		let minPrice: number = 0;
		if (data.product.sizes) {
			minPrice = data.product.sizes[0].price;
		}
		if (data.product.quantity) {
			minPrice = data.product.quantity[0].price;
		}
		return minPrice;
	}

	function getMaxPrice(): number {
		let maxPrice: number = 0;
		if (data.product.sizes) {
			maxPrice = data.product.sizes[data.product.sizes.length - 1].price;
		}
		if (data.product.quantity) {
			maxPrice = data.product.quantity[data.product.quantity.length - 1].price;
		}
		if (data.product.extras) {
			const extrasList = Object.keys(productExtras);
			extrasList.forEach((extra) => {
				maxPrice += productExtras[extra].price;
			});
		}
		return maxPrice;
	}

	$: if (data.product.sizes) {
		sizePrice = data.product.sizes[sizeChoice].price;
		product.size = {
			name: data.product.sizes[sizeChoice].name,
			price: data.product.sizes[sizeChoice].price
		};
	}

	$: if (data.product.quantity) {
		QuantityPrice = data.product.quantity[quantityChoice].price;
		product.quantity = {
			name: data.product.quantity[quantityChoice].name,
			price: data.product.quantity[quantityChoice].price
		};
	}

	$: {
		if (product.flavour && flavours[product.flavour].price) {
			flavourPrice = flavours[product.flavour].price || 0;
		} else {
			flavourPrice = 0;
		}
		product.price = sizePrice + QuantityPrice + flavourPrice + extrasPrice;
	}

	$: if (data.product.extras) {
		const extrasList = Object.keys(extrasChoice);
		extrasPrice = 0;
		extrasList.forEach((extra) => {
			extrasPrice += extrasChoice[extra].price;
		});
		product.extras = extrasList.map((extra) => {
			return {
				name: extra,
				type: extrasChoice[extra].type,
				value: extrasChoice[extra].value,
				price: extrasChoice[extra].price
			};
		});
	}

	$: {
		totalPrice = sizePrice + QuantityPrice + flavourPrice + extrasPrice;
		product.price = totalPrice;
	}

	function checkCheckBox(event: Event) {
		const target = event.target as HTMLInputElement;
		if (target.checked) {
			const choice = target.value.toString();
			extrasChoice[choice] = {
				type: productExtras[choice].type,
				value: undefined,
				price: productExtras[choice].price
			};
		} else {
			delete extrasChoice[target.value.toString()];
			extrasChoice = extrasChoice;
		}
	}

	function checkNumberBox(event: Event) {
		const target = event.target as HTMLInputElement;
		const choice = target.value.trim();
		if (choice === '' || choice == '0') {
			delete extrasChoice[target.id.replace('-', ' ')];
			extrasChoice = extrasChoice;
		} else {
			extrasChoice[target.id.replace('-', ' ')] = {
				type: productExtras[target.id.replace('-', ' ')].type,
				value: choice,
				price: productExtras[target.id.replace('-', ' ')].price
			};
		}
	}

	function checkSelect(event: Event) {
		const target = event.target as HTMLSelectElement;
		const choice = target.value;
		if (choice === 'none') {
			delete extrasChoice[target.id.replace('-', ' ')];
			extrasChoice = extrasChoice;
		} else {
			extrasChoice[target.id.replace('-', ' ')] = {
				type: productExtras[target.id.replace('-', ' ')].type,
				value: choice,
				price: productExtras[target.id.replace('-', ' ')].price
			};
		}
	}

	function checkTextbox(event: Event) {
		const target = event.target as HTMLInputElement;
		const choice = target.value.trim();
		if (choice === '') {
			delete extrasChoice[target.id.replace('-', ' ')];
			extrasChoice = extrasChoice;
		} else {
			extrasChoice[target.id.replace('-', ' ')] = {
				type: productExtras[target.id.replace('-', ' ')].type,
				value: choice,
				price: productExtras[target.id.replace('-', ' ')].price
			};
		}
	}

	//Generates array of product notes
	function generateNotesList() {
		let notesList: Array<string> = [];
		if (data.product.notes) {
			notesList = data.product.notes;
		}
		//If product has flavour, add flavour notes
		if (product.flavour) {
			notesList = notesList.concat(flavours[product.flavour].notes);
		}
		//If product has top and bottom flavours, add notes from both flavours
		else if (product.topFlavour && product.bottomFlavour) {
			notesList = notesList.concat(flavours[product.topFlavour].notes);
			notesList = notesList.concat(
				flavours[product.bottomFlavour].notes.filter((note: string) => {
					if (product.topFlavour)
						return !flavours[product.topFlavour].notes.includes(note);
				})
			);
		}
		//If product has four pack flavours, add notes from all four flavours
		else if (
			product.packOneFlavour &&
			product.packTwoFlavour &&
			product.packThreeFlavour &&
			product.packFourFlavour
		) {
			notesList = notesList.concat(flavours[product.packOneFlavour].notes);
			notesList = notesList.concat(
				flavours[product.packTwoFlavour].notes.filter((note: string) => {
					if (product.packOneFlavour)
						return !flavours[product.packOneFlavour].notes.includes(note);
				})
			);
			notesList = notesList.concat(
				flavours[product.packThreeFlavour].notes.filter((note: string) => {
					if (product.packOneFlavour)
						return !flavours[product.packOneFlavour].notes.includes(note);
				})
			);
			notesList = notesList.concat(
				flavours[product.packFourFlavour].notes.filter((note: string) => {
					if (product.packOneFlavour)
						return !flavours[product.packOneFlavour].notes.includes(note);
				})
			);
		}
		//If product has three pack flavours, add notes from all three flavours
		else if (
			product.packOneFlavour &&
			product.packTwoFlavour &&
			product.packThreeFlavour
		) {
			notesList = notesList.concat(flavours[product.packOneFlavour].notes);
			notesList = notesList.concat(
				flavours[product.packTwoFlavour].notes.filter((note: string) => {
					if (product.packOneFlavour)
						return !flavours[product.packOneFlavour].notes.includes(note);
				})
			);
			notesList = notesList.concat(
				flavours[product.packThreeFlavour].notes.filter((note: string) => {
					if (product.packOneFlavour)
						return !flavours[product.packOneFlavour].notes.includes(note);
				})
			);
		}
		//If product has two pack flavours, add notes from both flavours
		else if (product.packOneFlavour && product.packTwoFlavour) {
			notesList = notesList.concat(flavours[product.packOneFlavour].notes);
			notesList = notesList.concat(
				flavours[product.packTwoFlavour].notes.filter((note: string) => {
					if (product.packOneFlavour)
						return !flavours[product.packOneFlavour].notes.includes(note);
				})
			);
		}
		//If product has one flavour, add notes from that flavour
		else if (data.product.flavour) {
			if (data.product.flavour.length === 1) {
				notesList = notesList.concat(flavours[data.product.flavour[0]].notes);
			}
		}
		return notesList;
	}

	//Generates array of product allergens
	function generateAllergensList() {
		let allergensList: Array<string> = [];
		//If product has flavour, add flavour allergens
		if (product.flavour) {
			allergensList = allergensList.concat(flavours[product.flavour].allergens);
		}
		//If product has top and bottom flavours, add allergens from both flavours
		else if (product.topFlavour && product.bottomFlavour) {
			allergensList = allergensList.concat(
				flavours[product.topFlavour].allergens
			);
			allergensList = allergensList.concat(
				flavours[product.bottomFlavour].allergens.filter((allergen: string) => {
					if (product.topFlavour)
						return !flavours[product.topFlavour].allergens.includes(allergen);
				})
			);
		}
		//If product has three pack flavours, add allergens from all three flavours
		else if (
			product.packOneFlavour &&
			product.packTwoFlavour &&
			product.packThreeFlavour
		) {
			allergensList = allergensList.concat(
				flavours[product.packOneFlavour].allergens
			);
			allergensList = allergensList.concat(
				flavours[product.packTwoFlavour].allergens.filter(
					(allergen: string) => {
						if (product.packOneFlavour)
							return !flavours[product.packOneFlavour].allergens.includes(
								allergen
							);
					}
				)
			);
			allergensList = allergensList.concat(
				flavours[product.packThreeFlavour].allergens.filter(
					(allergen: string) => {
						if (product.packOneFlavour)
							return !flavours[product.packOneFlavour].allergens.includes(
								allergen
							);
					}
				)
			);
		}
		//If product has two pack flavours, add allergens from both flavours
		else if (product.packOneFlavour && product.packTwoFlavour) {
			allergensList = allergensList.concat(
				flavours[product.packOneFlavour].allergens
			);
			allergensList = allergensList.concat(
				flavours[product.packTwoFlavour].allergens.filter(
					(allergen: string) => {
						if (product.packOneFlavour)
							return !flavours[product.packOneFlavour].allergens.includes(
								allergen
							);
					}
				)
			);
		}
		//If product has one flavour, add allergens from that flavour
		else if (data.product.flavour) {
			if (data.product.flavour.length === 1) {
				allergensList = allergensList.concat(
					flavours[data.product.flavour[0]].allergens
				);
			}
		}
		return allergensList;
	}

	function checkRules(extra: string): boolean {
		let condition: boolean = true;
		const rules = productExtras[extra].rules;
		if (!rules) return true;
		for (const rule of Object.keys(rules)) {
			switch (rule) {
				case 'baseFlavours':
					let productFlavours: string[] = [];
					if (product.flavour) {
						productFlavours = flavours[product.flavour].baseFlavours;
					} else if (product.topFlavour && product.bottomFlavour) {
						productFlavours = Array.from(
							new Set([
								...flavours[product.topFlavour].baseFlavours,
								...flavours[product.bottomFlavour].baseFlavours
							])
						);
					} else if (
						product.packOneFlavour &&
						product.packTwoFlavour &&
						product.packThreeFlavour
					) {
						productFlavours = Array.from(
							new Set([
								...flavours[product.packOneFlavour].baseFlavours,
								...flavours[product.packTwoFlavour].baseFlavours,
								...flavours[product.packThreeFlavour].baseFlavours
							])
						);
					} else if (product.packOneFlavour && product.packTwoFlavour) {
						productFlavours = Array.from(
							new Set([
								...flavours[product.packOneFlavour].baseFlavours,
								...flavours[product.packTwoFlavour].baseFlavours
							])
						);
					}

					for (const baseFlavour of rules[rule]) {
						if (!productFlavours.includes(baseFlavour)) {
							condition = false;
							break;
						}
					}
					break;
				default:
					break;
			}
		}
		if (condition === false && extra.replace(' ', '-') in selects) {
			selects[extra.replace(' ', '-')].value = 'none';
			delete extrasChoice[extra];
			extrasChoice = extrasChoice;
		}
		return condition;
	}
</script>

{@html `<script lang="JSON-ld">
{
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "${data.product.name}",
  "description": "${data.product.description ? data.product.description.join(' ') : ''}",
  "category": "${data.product.category}",
  "sku": "${data.product._id}",
  "image": "https://takethecake.gumlet.io/${data.product._id}/${data.product.thumbnail.src.replace(' ', '%20')}",
  "additionalImage": ${JSON.stringify(additionalImages)},
  "offers": {
    "@type": "Offer",
    "priceCurrency": "EUR",
    "lowPrice": "${minPrice}",
    "highPrice": "${maxPrice}",
    "availability": "https://schema.org/InStock",
    "url": "https://takethecake.ie/products/${data.product._id}",
    "shippingDetails": [
      {
        "@type": "OfferShippingDetails",
        "shippingRate": {
          "@type": "MonetaryAmount",
          "value": "8.00",
          "currency": "EUR"
        },
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "businessDays": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "https://schema.org/Monday",
              "https://schema.org/Tuesday",
              "https://schema.org/Wednesday",
              "https://schema.org/Thursday",
              "https://schema.org/Friday",
              "https://schema.org/Saturday",
              "https://schema.org/Sunday"
            ],
            "opens": "08:00",
            "closes": "12:00"
          },
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 2,
            "maxValue": 2,
            "unitCode": "d"
          },
          "transitTime": {
            "@type": "QuantitativeValue",
            "minValue": 0,
            "maxValue": 0,
            "unitCode": "d"
          }
        },
		"appliesToDeliveryMethod": "https://schema.org/DeliveryModeDirect",
        "shippingDestination": {
          "@type": "Place",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Dublin",
            "addressCountry": "IE"
          }
        }
      },
      {
        "@type": "OfferShippingDetails",
        "shippingRate": {
          "@type": "MonetaryAmount",
          "value": "0.00",
          "currency": "EUR"
        },
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "businessDays": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "https://schema.org/Monday",
              "https://schema.org/Tuesday",
              "https://schema.org/Wednesday",
              "https://schema.org/Thursday",
              "https://schema.org/Friday",
              "https://schema.org/Saturday",
              "https://schema.org/Sunday"
            ],
            "opens": "08:00",
            "closes": "18:00"
          },
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 2,
            "maxValue": 2,
            "unitCode": "d"
          },
          "transitTime": {
            "@type": "QuantitativeValue",
            "minValue": 0,
            "maxValue": 0,
            "unitCode": "d"
          }
        },
        "appliesToDeliveryMethod": "https://schema.org/pickup",
        "shippingDestination": {
          "@type": "Place",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "IE"
          }
        }
      }
    ]
  }
}</script>`}

<svelte:head>
	<title>{data.product.name}</title>
	{#if data.product.description}
		<meta name="description" content={data.product.description.join(' ')} />
	{/if}
</svelte:head>

{#if productNotesList.length > 0 || productAllergensList.length > 0}
	<div class=" flex flex-col bg-logoFontGold px-4 py-3 text-white">
		<h2 class="text-center text-2xl font-bold">
			<span class="fa-duotone fa-bullhorn mr-2"></span>Important Notices
		</h2>
		{#if productNotesList.length > 0}
			<div class="flex gap-2">
				<h3 class="text-md font-semibold">Notes:</h3>
				<ul>
					{#each productNotesList as note}
						<li>{note}</li>
					{/each}
				</ul>
			</div>
		{/if}
		{#if productAllergensList.length > 0}
			<div class="flex gap-2">
				<h3 class="text-md font-semibold">Allergens:</h3>
				<ul class="flex">
					{#each productAllergensList as allergen, index}
						<li>
							{allergen}{@html index < productAllergensList.length - 1
								? ',&nbsp;'
								: ''}
						</li>
					{/each}
				</ul>
			</div>
		{/if}
	</div>
{/if}

<div class="mt-5 flex flex-col md:mx-auto md:w-[90%] md:flex-row md:gap-12">
	<div class="block md:w-[150%]">
		<wa-carousel
			loop
			navigation
			pagination
			mouse-dragging
			style="--pagination-color-active:#7aa6d7;"
		>
			{#each [data.product.thumbnail, ...data.product.images] as image}
				<wa-carousel-item>
					<img
						data-src={`https://takethecake.gumlet.io/${data.product._id}/${image.src.replace(' ', '%20')}`}
						alt={image.alt}
						class="h-full object-contain"
					/>
				</wa-carousel-item>
			{/each}
		</wa-carousel>
		<div class="mt-3">
			<div class="mx-auto w-[90%]">
				<h2 class="flex flex-col text-2xl font-medium text-gray-900">
					<span>{data.product.name}</span>
					{#if !data.product.available}
						<span class="text-red-600">(Temporarily Unavailable)</span>
					{/if}
				</h2>
				{#if data.product.description}
					<div class="mt-1 text-sm text-gray-700">
						{#each data.product.description as description}
							<p>{description}</p>
						{/each}
					</div>
				{/if}
			</div>
		</div>
	</div>
	<div class="mx-auto mt-8 w-[90%] space-y-4 md:mt-0">
		<span class="mb-2.5 flex items-center">
			<span class="h-px flex-1 bg-black"></span>
			<h3 class="shrink-0 px-6 leading-none">Product Details</h3>
			<span class="h-px flex-1 bg-black"></span>
		</span>
		{#if data.product.fulfilmentDates}
			<p class="text-red-500">
				Available ONLY from {formatFulfilmentDates(
					data.product.fulfilmentDates.start
				)} until {formatFulfilmentDates(data.product.fulfilmentDates.end)} for collection
				and delivery.
			</p>
		{/if}
		{#if data.product.sizes}
			{#if data.product.sizes.length > 1}
				<div class="space-y-0">
					<label
						class="block text-sm font-medium text-gray-900"
						for="productSize">Size:</label
					>
					<select
						class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
						id="productSize"
						bind:value={sizeChoice}
					>
						{#each data.product.sizes as size, index}
							<option value={index}>{size.description}: €{size.price}</option>
						{/each}
					</select>
				</div>
			{:else if data.product.sizes[0].description}
				<p>Size: {data.product.sizes[0].description}</p>
				<p>Price: €{data.product.sizes[0].price}</p>
			{:else}
				<p>Price: €{data.product.sizes[0].price}</p>
			{/if}
		{/if}
		{#if data.product.quantity}
			{#if data.product.quantity.length > 1}
				<div class="space-y-0">
					<label
						class="block text-sm font-medium text-gray-900"
						for="productQuantity">Quantity:</label
					>
					<select
						class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
						id="productQuantity"
						bind:value={quantityChoice}
					>
						{#each data.product.quantity as quantity, index}
							<option value={index}>{quantity.name}: €{quantity.price}</option>
						{/each}
					</select>
				</div>
			{:else}
				<p>Quantity: {data.product.quantity[0].name}</p>
				<p>Price: €{data.product.quantity[0].price}</p>
			{/if}
		{/if}
		{#if data.product.shape}
			<div class="space-y-0">
				<label
					class="block text-sm font-medium text-gray-900"
					for="productShape">Shape:</label
				>
				<select
					class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
					id="productShape"
					bind:value={product.shape}
				>
					{#each data.product.shape.sort() as shape}
						<option value={shape}>{shape}</option>
					{/each}
				</select>
			</div>
		{/if}
		{#if data.product.flavour}
			{#if data.product.flavour.length > 1}
				<div class="space-y-0">
					<label
						class="block text-sm font-medium text-gray-900"
						for="productFlavour">Flavour:</label
					>
					<select
						class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
						id="productFlavour"
						bind:value={product.flavour}
					>
						{#each data.product.flavour.sort() as flavour}
							<option value={flavour}
								>{flavours[flavour].name}{flavours[flavour].price
									? ' +€' + flavours[flavour].price
									: ''}</option
							>
						{/each}
					</select>
				</div>
			{:else}
				<p>Flavour: {flavours[data.product.flavour[0]].name}</p>
			{/if}
		{/if}
		{#if data.product.topFlavour}
			<div class="space-y-0">
				<label
					class="block text-sm font-medium text-gray-900"
					for="productTopFlavour">Top Flavour:</label
				>
				<select
					class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
					id="productTopFlavour"
					bind:value={product.topFlavour}
				>
					{#each data.product.topFlavour.sort() as topFlavour}
						<option value={topFlavour}>{flavours[topFlavour].name}</option>
					{/each}
				</select>
			</div>
		{/if}
		{#if data.product.bottomFlavour}
			<div class="space-y-0">
				<label
					class="block text-sm font-medium text-gray-900"
					for="productBottomFlavour">Bottom Flavour:</label
				>
				<select
					class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
					id="productBottomFlavour"
					bind:value={product.bottomFlavour}
				>
					{#each data.product.bottomFlavour.sort() as bottomFlavour}
						<option value={bottomFlavour}>{flavours[bottomFlavour].name}</option
						>
					{/each}
				</select>
			</div>
		{/if}
		{#if data.product.packOneFlavour}
			<div class="space-y-0">
				<label
					class="block text-sm font-medium text-gray-900"
					for="productPackOneFlavour">Pack One Flavour:</label
				>
				<select
					class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
					id="productPackOneFlavour"
					bind:value={product.packOneFlavour}
				>
					{#each data.product.packOneFlavour.sort() as packOneFlavour}
						<option value={packOneFlavour}
							>{flavours[packOneFlavour].name}</option
						>
					{/each}
				</select>
			</div>
		{/if}
		{#if data.product.packTwoFlavour}
			<div class="space-y-0">
				<label
					class="block text-sm font-medium text-gray-900"
					for="productPackTwoFlavour">Pack Two Flavour:</label
				>
				<select
					class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
					id="productPackTwoFlavour"
					bind:value={product.packTwoFlavour}
				>
					{#each data.product.packTwoFlavour.sort() as packTwoFlavour}
						<option value={packTwoFlavour}
							>{flavours[packTwoFlavour].name}</option
						>
					{/each}
				</select>
			</div>
		{/if}
		{#if data.product.packThreeFlavour}
			<div class="space-y-0">
				<label
					class="block text-sm font-medium text-gray-900"
					for="productPackThreeFlavour">Pack Three Flavour:</label
				>
				<select
					class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
					id="productPackThreeFlavour"
					bind:value={product.packThreeFlavour}
				>
					{#each data.product.packThreeFlavour.sort() as packThreeFlavour}
						<option value={packThreeFlavour}
							>{flavours[packThreeFlavour].name}</option
						>
					{/each}
				</select>
			</div>
		{/if}
		{#if data.product.colour}
			<div class="space-y-0">
				<label
					class="block text-sm font-medium text-gray-900"
					for="productColour">Colour:</label
				>
				<select
					class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
					id="productColour"
					bind:value={product.colour}
				>
					{#each data.product.colour.sort() as colour}
						<option value={colour}>{colour}</option>
					{/each}
				</select>
			</div>
		{/if}
		{#if data.product.text}
			<div class="space-y-0">
				<label class="block text-sm font-medium text-gray-900" for="productText"
					>Text:</label
				>
				<input
					class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue"
					type="text"
					id="productText"
					maxlength="30"
					bind:value={product.text}
				/>
			</div>
		{/if}
		{#if data.product.extras}
			<span class="mb-2.5 flex items-center pt-8">
				<span class="h-px flex-1 bg-black"></span>
				<h3 class="shrink-0 px-6 leading-none">Extras</h3>
				<span class="h-px flex-1 bg-black"></span>
			</span>
			{#each data.product.extras as extra}
				{#if productExtras[extra].type === 'checkbox'}
					<div class="space-y-0">
						<div class="flex items-start space-x-2">
							<input
								id={extra.replace(' ', '-')}
								class="mt-1 size-5 rounded border-gray-300 checked:bg-logoBackgroundBlue checked:text-logobackgroundBlueRgba focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue"
								type="checkbox"
								value={extra}
								on:change={(event) => checkCheckBox(event)}
							/>
							<label
								class="flex-1 text-sm font-medium text-gray-700"
								for={extra.replace(' ', '-')}
								>{extra}{#if productExtras[extra].price > 0}: €{productExtras[
										extra
									].price}
								{/if}
								{#if productExtras[extra].description}
									<p class="text-sm">{productExtras[extra].description}</p>
								{/if}
							</label>
						</div>
					</div>
				{:else if productExtras[extra].type === 'text'}
					<div class="space-y-0">
						<label
							class="block text-sm font-medium text-gray-900"
							for={extra.replace(' ', '-')}
							>{extra}{#if productExtras[extra].price > 0}: €{productExtras[
									extra
								].price}
							{/if}
						</label>
						<input
							class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue"
							type="text"
							id={extra.replace(' ', '-')}
							maxlength={productExtras[extra].maxLength}
							on:input={(event) => checkTextbox(event)}
						/>
					</div>
				{:else if productExtras[extra].type === 'select' && productExtras[extra].options}
					<div class="space-y-0">
						<label
							class="block text-sm font-medium text-gray-900"
							for={extra.replace(' ', '-')}
							>{extra}: €{productExtras[extra].price}</label
						>
						<select
							class="mt-1.5 w-full rounded-lg border-gray-300 text-gray-700 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue sm:text-sm"
							id={extra.replace(' ', '-')}
							disabled={!checkRules(extra)}
							bind:this={selects[extra.replace(' ', '-')]}
							on:change={(event) => checkSelect(event)}
						>
							{#if !productExtras[extra].default}
								<option value="none" selected>None</option>
							{/if}
							{#each (productExtras[extra].options ?? []).sort() as option}
								<option
									value={option}
									selected={productExtras[extra].default == option}
									>{option}</option
								>
							{/each}
						</select>
					</div>
				{:else if productExtras[extra].type === 'number' && productExtras[extra].maxValue}
					<div class="space-y-0">
						<label
							class="block text-sm font-medium text-gray-900"
							for={extra.replace(' ', '-')}
							>{extra}{#if productExtras[extra].price > 0}
								: €{productExtras[extra].price}
							{/if}</label
						>
						<input
							class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue"
							type="number"
							id={extra.replace(' ', '-')}
							min="0"
							max={productExtras[extra].maxValue}
							on:input={(event) => checkNumberBox(event)}
						/>
					</div>
				{/if}
			{/each}
		{/if}
		{#if data.relatedProducts}
			<div class="flex w-full flex-col">
				<span class="mb-2.5 flex w-full items-center pt-8">
					<span class="h-px flex-1 bg-black"></span>
					<h4 class="shrink-0 px-6 leading-none">Related Products</h4>
					<span class="h-px flex-1 bg-black"></span>
				</span>
				<div class="related-products">
					<ul class="flex flex-wrap gap-4">
						{#each data.relatedProducts as relatedProduct}
							{#if relatedProduct}
								<li class="flex w-full flex-col gap-4 pt-4 md:flex-row">
									<div class="flex flex-col md:w-1/2">
										<a href={`/products/${relatedProduct?.id}`} class="w-2/3">
											<img
												class="h-auto w-full object-contain"
												src={`https://takethecake.gumlet.io/${relatedProduct.id}/${relatedProduct.thumbnail.src.replace(' ', '%20')}`}
												alt={relatedProduct.thumbnail.alt}
											/>
										</a>
										<h5
											class="mt-2 text-xl font-medium text-gray-900 group-hover:text-gray-600"
										>
											<a
												href={`/products/${relatedProduct.id}`
													.toLowerCase()
													.replace(/\s+/g, '-')}
											>
												{relatedProduct.name}
											</a>
										</h5>
										<p class="text-base">
											€{relatedProduct.price}
										</p>
									</div>
									<div class="flex w-full flex-col justify-between gap-4">
										<p class="mt-2 text-left">
											{relatedProduct.description}
										</p>
										<button
											class="mx-auto block w-1/3 rounded bg-logoBackgroundBlue px-3 py-2 text-sm text-gray-100 transition hover:bg-logobackgroundBlueRgba focus:bg-logobackgroundBlueRgba disabled:cursor-not-allowed disabled:bg-gray-300"
											on:click={() => {
												let success = cart.addItem(
													JSON.parse(JSON.stringify(relatedProduct)),
													1
												);
												if (success) {
													toasts.add({
														message: `Added 1x ${relatedProduct.name} to your cart`,
														type: 'success'
													});
												} else {
													toasts.add({
														message: `Sorry but something went wrong when trying to add the ${relatedProduct.name} to your cart!`,
														type: 'error'
													});
												}
											}}
											><span class="text-sm font-medium">Add to order</span>
											<span
												class="fa-solid fa-plus size-3 text-white group-disabled:text-gray-300"
											></span>
										</button>
									</div>
								</li>
							{/if}
						{/each}
					</ul>
				</div>
			</div>
		{/if}
		<div class="space-y-0">
			<label
				class="block text-sm font-medium text-gray-900"
				for="productInstructions">Special Instructions:</label
			>
			<textarea
				class="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-logoBackgroundBlue focus:ring-logoBackgroundBlue"
				id="productInstructions"
				rows="3"
				bind:value={product.instructions}
			></textarea>
		</div>

		<div class="flex justify-center gap-2 py-8">
			<button
				on:click={() => {
					if (productQuantity > 1) {
						productQuantity -= 1;
					}
				}}
				aria-label="Decrease quantity"
				disabled={productQuantity <= 1}
				class="hover:text-gray-600 focus:text-gray-600 disabled:cursor-not-allowed disabled:text-gray-300"
				>-</button
			>
			<input
				class="h-8 w-12 rounded border-gray-200 bg-gray-50 p-0 text-center text-xs text-gray-600 [-moz-appearance:_textfield] hover:border-logoBackgroundBlue hover:outline-none hover:ring-1 hover:ring-logoBackgroundBlue focus:border-logoBackgroundBlue focus:outline-none focus:ring-1 focus:ring-logoBackgroundBlue [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none"
				type="number"
				bind:value={productQuantity}
				min="1"
			/>
			<button
				on:click={() => {
					productQuantity += 1;
				}}
				aria-label="Increase quantity"
				class="hover:text-gray-600 focus:text-gray-600">+</button
			>
		</div>

		<div class="mx-auto flex w-fit gap-4">
			<p
				class="my-auto h-fit w-fit whitespace-nowrap rounded-full bg-logoFontPurple px-2.5 py-2 text-sm text-white"
			>
				Total: €{totalPrice * productQuantity}
			</p>
			<button
				aria-label="Add to cart"
				class="group block rounded border border-logoBackgroundBlue px-5 py-3 text-sm text-logoBackgroundBlue transition hover:ring-1 hover:ring-logobackgroundBlueRgba focus:ring-1 focus:ring-logobackgroundBlueRgba disabled:cursor-not-allowed disabled:border-gray-300 disabled:text-gray-300 disabled:hover:ring-gray-300 disabled:focus:ring-gray-300"
				disabled={totalPrice <= 0 ||
					productQuantity <= 0 ||
					!data.product.available}
				on:click={() => {
					let success = cart.addItem(
						JSON.parse(JSON.stringify(product)),
						productQuantity
					);
					if (success) {
						toasts.add({
							message: `Added ${productQuantity}x ${product.name} to your cart`,
							type: 'success'
						});
					} else {
						toasts.add({
							message: `Sorry but something went wrong when trying to add the ${product.name} to your cart!`,
							type: 'error'
						});
					}
				}}
				><span class="text-sm font-medium">Add to cart</span><span
					class="fa-duotone fa-cart-shopping size-5 text-logoBackgroundBlue group-disabled:text-gray-300"
				></span></button
			>
		</div>
	</div>
</div>
